import {
  PhoneOutline18Icon,
  PhoneOutline24Icon,
} from "@vygruppen/spor-icon-react";
import { replacePhoneNumberPrefix } from "features/Header/PuzzelTelephone/utils";
import { ButtonHTMLAttributes, FC } from "react";
import { DropsButton, DropsTooltip } from "shared/components/Spor";
import { usePuzzelCurrentlyCalling } from "stores/usePuzzleCurrentlyCalling";

type Size = "xs" | "sm";

export const getCallIcon = (size: Size) => {
  switch (size) {
    case "xs":
      return <PhoneOutline18Icon />;
    case "sm":
      return <PhoneOutline24Icon />;
  }
};

export interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  phoneNumber: string;
  label?: string;
  size: Size;
  insideButton?: boolean;
}

/**
 * Secondary button with tooltip on hover, for initiating calls via Puzzel.
 * @param id - ID for linking up the button and tooltip components
 * @param phoneNumber - Phone number to initiate call with.
 * @param label - Optional label to display instead of the phone number.
 * @param size - Size of the secondary Button; only possible to choose between x-small and small atm.
 */
export const CallButton: FC<Props> = ({
  phoneNumber,
  label,
  size,
  insideButton,
  ...props
}) => {
  const { setCurrentlyCalling } = usePuzzelCurrentlyCalling();

  const noPrefixPhoneNumber = replacePhoneNumberPrefix(phoneNumber);

  const toolTipText = ["Ring til", noPrefixPhoneNumber, label]
    .filter(Boolean)
    .join(" ");

  return (
    <DropsTooltip hasArrow placement="top" label={toolTipText}>
      <DropsButton
        variant="tertiary"
        size={size}
        leftIcon={<div>{getCallIcon(size)}</div>}
        aria-label={`Ring til ${noPrefixPhoneNumber} ${label}`}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setCurrentlyCalling(phoneNumber);
        }}
        as={insideButton ? "span" : "button"}
        {...props}
      >
        {label ?? noPrefixPhoneNumber}
      </DropsButton>
    </DropsTooltip>
  );
};
